module.exports = __webpack_public_path__ + "media/images/admin/icons/shopping-cart-33ce5d1587bf4a7a971bb64d9418e125.svg";